import { CSSProperties } from "react";
import {
  autoUpdate,
  flip,
  offset,
  size,
  useFloating as useFloatingBase,
} from "@floating-ui/react";
import { Props } from "./UseFloating.Parts";

export const useFloating = ({
  open,
  onOpenChange,
  offset: offsetValue = 16,
}: Props) => {
  const { refs, floatingStyles, context } = useFloatingBase({
    elements: {
      reference: null,
    },
    open,
    onOpenChange,
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(offsetValue),
      size({
        apply({ elements, availableHeight, availableWidth, rects }) {
          const styles: CSSProperties = {
            maxHeight: `${availableHeight}px`,
            maxWidth: `${availableWidth}px`,
            width: `${rects.reference.width}px`,
          };

          Object.assign(elements.floating.style, styles);
        },
        padding: 10,
      }),
      flip({
        fallbackStrategy: "initialPlacement",
        padding: 4,
      }),
    ],
  });

  return { refs, floatingStyles, context };
};
